(() => {
  angular
    .module('gm.common.conversion')
    .filter('gmyConvertToGold', gmyConvertToGold);

  function gmyConvertToGold(
    GmyCurrencyConverter
  ) {
    'ngInject';

    const convertToGold = (currencyAmount, currencyCode) =>
      GmyCurrencyConverter.fromCurrencyToGold(currencyCode, currencyAmount);

    convertToGold.$stateful = true;
    return convertToGold;
  }
})();
